import React from 'react'
import Courses from '../courses/Course'
import About from '../about/About'
import Presentations from '../presentations/Presentations'
import Intro from '../intro/Intro'
import Footer from '../footer/Footer'

export default function Home() {
  return (
    <div>
      <Intro />
      <Courses />
      <Presentations />
     
    </div>
  )
}
